Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    iconColorPrimary: tokens.themeInkDefault,
    iconColorSecondary: tokens.themeInkSubdued,
    iconColorInverted: tokens.themeInkInverse,
    iconColorError: tokens.themeSupportInkError,
    iconColorWarning: tokens.themeSupportInkWarning,
    iconColorSuccess: tokens.themeSupportInkSuccess,
    iconSizeUtility: 16,
    iconSizeStandard: 24
  }
};